






























import MNotificationVue from "@/mixins/MNotification.vue";
import { cashFlowReportService } from "@/services/cash-flow-report.service";
import { currencyFormat } from "@/validator/globalvalidator";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";

interface TransactionItem {
  id: string;
  accountCode: string;
  accountDescription: string;
  amount: number;
}

const DETAIL_COLUMNS = [
  {
    title: "lbl_account_code",
    dataIndex: "accountCode",
    key: "accountCode",
  },
  {
    title: "lbl_account_description",
    dataIndex: "accountDescription",
    key: "accountDescription",
  },
  {
    title: "lbl_amount",
    dataIndex: "amount",
    key: "amount",
    align: "right",
    scopedSlots: { customRender: "amount" },
  },
] as const;

@Component
export default class CashFlowReportDetailModal extends Mixins(
  MNotificationVue
) {
  @Prop({ default: false }) visible!: boolean;
  @Prop({ default: "" }) categoryId!: string;
  @Prop({ default: "" }) dateFrom!: string;
  @Prop({ default: "" }) dateTo!: string;

  loading = false;
  dataSource: TransactionItem[] = [];
  totalAmount = 0;
  currencyFormat = currencyFormat;

  formatAmount(value: number | string | null | undefined): string {
    const formatted = this.currencyFormat(value) || "0.00";
    if (formatted.startsWith("-")) {
      return `(${formatted.slice(1)})`;
    }
    return formatted;
  }

  @Watch("visible")
  onVisibleChange(newValue: boolean): void {
    if (newValue && this.categoryId) {
      this.fetchDetail();
    }
  }

  get columns() {
    return DETAIL_COLUMNS.map(col => ({
      ...col,
      title: this.$t(col.title).toString(),
    }));
  }

  async fetchDetail(): Promise<void> {
    try {
      this.loading = true;
      const response = await cashFlowReportService.getDetail({
        categoryId: this.categoryId,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
      });

      this.dataSource = response.items.map((item, index) => ({
        id: item.accountCode || `${index}`,
        accountCode: item.accountCode,
        accountDescription: item.accountDescription,
        amount: item.amount,
      }));

      this.totalAmount = response.totalAmount;
    } catch {
      this.showNotifError("err_failed_to_load_cash_flow_report");
    } finally {
      this.loading = false;
    }
  }

  handleClose(): void {
    this.$emit("cancel");
  }
}
